module.exports = __webpack_public_path__ + "img/cicon.f9575a25.svg";